import React from 'react'
import { Button, Flex } from '@workwhile/ui'
import { Pencil } from 'lucide-react'
import { InvoiceConfigRow } from '../types'
import { useInvoiceConfigWorkflowsContextValue } from '../context/InvoiceConfigWorkflowsProvider'
import { useWhoamiContextValue } from 'components/Whoami'

export const ActionsCell = ({
  invoiceConfig,
}: {
  invoiceConfig: InvoiceConfigRow
}) => {
  const { editInvoiceConfigFlow } = useInvoiceConfigWorkflowsContextValue()
  const { hasPermission } = useWhoamiContextValue()
  const canManageBilling = hasPermission('finance_specialist')

  if (!canManageBilling) {
    return null
  }

  return (
    <Flex justifyContent="center" alignItems="center" width="100%">
      <Button
        variant="secondary"
        kind="small"
        aria-label="Edit invoice config"
        onClick={() => editInvoiceConfigFlow.open(invoiceConfig)}
      >
        <Pencil size={14} />
      </Button>
    </Flex>
  )
}
